import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction } from "../state/State";
import { uiActions } from "../state/UiReducer";

/**
 * @name PlayerLeader
 * @class PlayerLeader
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class PlayerLeader extends ConnectedHTMLElement {
  static observedAttributes = ["player", "align"];

  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    const player = this.getAttribute("player");
    if (newState[player].leader !== oldState[player].leader) {
      this.render();
    }
  }
  registerElementEvents() {
    const player = this.getAttribute("player");
    const openLeaderModalBtn = this.querySelector("#open-leader-modal");
    if (openLeaderModalBtn === null) return;
    openLeaderModalBtn.addEventListener("click", () => {
      DispatchAction(uiActions.toggleSelectLeader, { show: true, player });
    });
  }

  render() {
    const player = this.getAttribute("player");
    const align = this.getAttribute("align");
    const leader = this.state[player].leader;
    let profileImg = "/assets/icons/yoda.svg";
    let leaderName = "Select leader";
    if (leader !== undefined) {
      profileImg = `/assets/img/p_${leader.id}.png`;
      leaderName = player;
    }

    this.innerHTML = `
      <button
        class="leader-profile ${align === "bottom" ? "bottom" : ""}"
        id="open-leader-modal"
      >
        <img src="${profileImg}" width="32" height="32" alt="${leaderName}" />
        <p>${leaderName}</p>
      </button>
    `;
    this.registerElementEvents();
  }

  connectedCallback() {
    this.render();
  }
}
